<script setup>
import {defineProps, ref} from "vue";
import NextButton from "../NextButton.vue";

const {flowState} = defineProps(['visible', 'flowState']);

// Set consultWithSpecialist to Yes and set source
flowState.setFormValue('consultWithSpecialist', 'Yes');
flowState.setFormValue('source', 'Franchise specialist cta');

const errors = ref({
	firstName: false,
	lastName: false,
	email: false
});

const onFirstNameChange = (e) => {
	flowState.setFormValue('firstName', e.target.value.trim());
}

const onLastNameChange = (e) => {
	flowState.setFormValue('lastName', e.target.value.trim());
}

const onEmailChange = (e) => {
	flowState.setFormValue('email', e.target.value.trim());
};

const emailRegex = /^[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*(\+[a-zA-Z0-9-]+)?@[a-z0-9-.]+(\.[a-zA-Z0-9]+)$/;
let onlyLetters = /^[a-zA-Z�-�\u00f1\u00d1\u00E0-\u00FC]+$/;

const checkInvalid = (field) => {
	// Get field value
	const fieldData = flowState.value[field];

	// Validate fields
	if (field === 'firstName' || field === 'lastName') {
		if (fieldData === '') {
			errors.value[field] = 'Field is required';
		} else if (!onlyLetters.test(fieldData)) {
			errors.value[field] = 'Enter a valid Name';
		} else {
			errors.value[field] = false;
		}
	} else if (field === 'email') {
		if (fieldData === null || fieldData === '') {
			errors.value[field] = 'Email is required';
		} else if (!emailRegex.test(fieldData)) {
			errors.value[field] = 'Invalid email';
		} else {
			errors.value[field] = false;
		}
	}
}

const checkErrors = () => {
	return errors.value.firstName === false
		&& errors.value.lastName === false
		&& errors.value.email === false;
}

const notNullValues = () => {
	return flowState.value.firstName !== null &&
		flowState.value.lastName !== null &&
		flowState.value.email !== null;
}

const stepIsReady = () => {
	// Check if all fields are filled and valid
	return checkErrors() && notNullValues();
}

const checkNextStep = async () => {
	$('.btn-next').hide();
	$('#loadingBtn').show();

	// Clear error message
	$('#showPhoneErrorMessage').hide();

	try {
		// Save email to hubspot
		await flowState.services.submitNameEmail(flowState.userData());

	} catch (e) {
		console.log(e)
	}

	flowState.nextTwoSteps();
}

</script>

<template>
	<div v-if="visible">
		<div class="tab">
			<div class="row">
				<div class="col-12">
					<p class="small-text-bold mb-0">Your email<span class="text-danger ms-1">*</span></p>
					<p>
						<input
							id="email"
							type="text"
							placeholder="example@mail.com"
							@change="onEmailChange"
							@blur="checkInvalid('email')"
							:value="flowState.value.email"
						/>
						<span v-if="errors.email" class="validationMessage text-danger ps-2 pe-2">
                        {{ errors.email }}
                    </span>
					</p>
				</div>
			</div>
			<div class="row mt-0 mb-0">
				<div class="col-12 col-md-6">
					<p class="small-text-bold mb-0">First name<span class="text-danger ms-1">*</span></p>
					<p>
						<input
							type="text"
							placeholder="John"
							:value="flowState.value.firstName"
							@change="onFirstNameChange"
							@blur="checkInvalid('firstName')"
						/>
						<span v-if="errors.firstName !== false" class="validationMessage text-danger ps-2 pe-2">
              {{ errors.firstName }}
            </span>
					</p>
				</div>
				<div class="col-12 col-md-6">
					<p class="small-text-bold mb-0">Last name<span class="text-danger ms-1">*</span></p>
					<p>
						<input
							type="text"
							placeholder="Doe"
							:value="flowState.value.lastName"
							@change="onLastNameChange"
							@blur="checkInvalid('lastName')"
						/>
						<span v-if="errors.lastName !== false" class="validationMessage text-danger ps-2 pe-2">
              {{ errors.lastName }}
            </span>
					</p>
				</div>
			</div>
		</div>
		<div>
			<NextButton
				:text="flowState.nextButtonText()"
				:enabled="stepIsReady()"
				:sidebar-text="true"
				@click="() => { checkNextStep() }"
			/>
			<div id="loadingBtn" class="mt-4">
				<span id="loader"></span>
			</div>
		</div>
	</div>
</template>